/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SysqueFrameModule } from '../../../../../../../shared/ui/src/lib/components/sysque-frame';
import { SysqueAlertModule } from 'libs/sysque/shared/ui/src/lib/components/sysque-alert';
import { RouterModule, Routes } from '@angular/router';
import { DxButtonModule, DxCircularGaugeModule, DxNumberBoxModule } from 'devextreme-angular';
import { SysqueGaugeComponent } from './sysque-gauge-component';

const routes: Routes = [{ path: 'dialog/sysque-gauge-dialog', component: SysqueGaugeComponent }];

@NgModule({
  declarations: [SysqueGaugeComponent],
  imports: [
    CommonModule,
    DxButtonModule,
    SysqueFrameModule,
    SysqueAlertModule,
    DxCircularGaugeModule,
    DxNumberBoxModule,
    RouterModule.forChild(routes),
  ],
  exports: [SysqueGaugeComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SysqueGaugeModule {}
